
import { Avatar,Button, Paper,Grid,Typography,Container, TextField } from '@material-ui/core';
import {GoogleLogin} from 'react-google-login';
import React,{useState} from 'react';
import { useDispatch } from 'react-redux';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { AUTH } from '../../constants/actionTypes';
import useStyles from './styles';
import {useNavigate} from 'react-router-dom';
import Input from './Input';
import Icon from './Icon';
import {signin,signup} from '../../actions/auth';
const Auth = () => {
  const initialState = {firstName:'',lastName:'',email:'',password:'',confirmPassword:''}
  const classes = useStyles();
  const [showPassword,setShowPassword] = useState(false);
  const handleShowPassword =  () => setShowPassword((prevShowPassword) => !prevShowPassword);
  const [isSignup,setIsSignup] = useState(false);
  const [formData,setFormData] = useState(initialState);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSubmit = (e) => {  
    e.preventDefault();
    console.log(formData);

    if(isSignup){
      dispatch(signup(formData,navigate));
    }
    else{
      dispatch(signin(formData,navigate))
    }
  };
  const handleChange = (e) => { 
    setFormData({...formData,[e.target.name]:e.target.value})

   };
  const switchMode = ()=>{setIsSignup((prevIsSignup)=>!prevIsSignup);
    setShowPassword(false); 
  };
   const googleSuccess = async(res)=>{
     //console.log(res);
     const result = res?.profileObj;
     const token = res?.tokenId;
     try {
       dispatch({type:AUTH,data:{result,token}});
       navigate('/');
     } catch (error) {
       console.log(error);
     }

   };
   const googleFailure = ()=>{
     console.log('Google Sign in was unsuccesful. Try again');
   };
              
  return (
    <Container component="main" maxWidth='xs'>
      <Paper className={classes.paper} elevation={3}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon/>
        </Avatar>
        <Typography variant='h5'>{isSignup? 'Sign Up':'Sign In'}</Typography>
        <form className={classes.form} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {
              isSignup && (
                <>
                  <Input name='firstName' label='First Name' handleChange={handleChange} autoFocus half/>
                  <Input name='lastName' label='Last Name' handleChange={handleChange} half />

                </>
              )
            }
            <Input name='email' label='Email Address' handleChange={handleChange} type='email'/>
            <Input name='password' label='Password' handleChange={handleChange} type={showPassword? 'text':'password'} handleShowPassword={handleShowPassword}/>
            {isSignup && <Input name='confirmPassword' label='Repeat Password' handleChange={handleChange} type='password'/>

            }

          </Grid>
          
          <Button type='submit' fullWidth variant='contained' color='primary' className={classes.submit}>
            {isSignup ? 'Sign Up':'Sign In'}
          </Button>
          <GoogleLogin 
              clientId='377754366925-6il6fah48bbnsor77o23s53jsf7l04l0.apps.googleusercontent.com'
              render={(renderProps)=>(
                <Button  className={classes.googleButton}  color='primary'  fullWidth  onClick={renderProps.onClick}  disabled={renderProps.disabled}  startIcon={<Icon/>}  variant='contained'>   Google Sign In </Button>
              )}
              onSuccess = {googleSuccess}
              onFailure = {googleFailure}

          />
          <Grid container justifyContent='flex-end'>
              <Grid item>
                <Button onClick={switchMode}>
                  {isSignup?'Already have an account? Sign In':'Dont have an account? Sign Up'}
                </Button>
              </Grid>
          </Grid>

        </form>

      </Paper>
    </Container>
  )
}

export default Auth